(function () {
    var controllerId = 'clinic.views.healthScreeningApplyGuaranteeLetterModal';
    var app = angular.module('app');
    app.controller(controllerId, [
      '$scope',
      '$uibModalInstance',
      '$filter',
      'abp.services.app.commonLookup',
      'abp.services.app.healthScreeningGuaranteeLetter',
      'clinic',
      'employee',
      function (
        $scope,
        $uibModalInstance,
        $filter,
        commonLookupSvc,
        healthScreeningGuaranteeLetterSvc,
        clinic,
        employee
      ) {
        function init() {
          getCurrencyCode();
        }

        var vm = this;
        vm.saving = 0;
        vm.loading = 0;
        vm.employee = employee;
        vm.clinic = clinic;
        vm.disciplineId = null;
        vm.isPatientInHospital = null;
        vm.hasValidGLAmount = false;

        vm.applyGuaranteeLetter = function () {
          vm.saving++;
          healthScreeningGuaranteeLetterSvc
            .applyGuaranteeLetter({
              employeeId: vm.employee.id,
              clinicLocationId: vm.clinic.clinicLocationId,
            })
            .success(function (letter) {
              $uibModalInstance.close(letter);
            })
            .finally(function () {
              vm.saving--;
            });
        };

        function setCoPayDisplay() {
          if (vm.employee.coPay) {
            if (vm.employee.coPay.isPercentage) {
              vm.coPayDisplay = {
                title: App.localize('CopayX', vm.employee.coPay.value + '%'),
                text: App.localize('CopayPercentage', vm.employee.coPay.value + '%'),
                value: vm.employee.coPay.value,
              };
            } else {
              var valueText = $filter('currencyFormat')(vm.employee.coPay.value, vm.currencyCode);
              vm.coPayDisplay = {
                title: App.localize('CopayX', valueText),
                text: App.localize('CopayFixedAmount', valueText),
                value: vm.employee.coPay.value,
              };
            }
          }
        }

        function getCurrencyCode() {
          vm.loading++;
          commonLookupSvc
            .getTenantCurrencyCode()
            .success(function (currencyCode) {
              vm.currencyCode = currencyCode;
              GetGuaranteeAmount();
              setCoPayDisplay();
            })
            .finally(function () {
              vm.loading--;
            });
        }

        function GetGuaranteeAmount() {
          vm.loading++;
          healthScreeningGuaranteeLetterSvc
            .getHealthScreeningGuaranteeAmount({ employeeId: vm.employee.id })
            .success(function (guaranteeAmount) {
              vm.guaranteeAmount = guaranteeAmount;
              vm.hasValidGLAmount = guaranteeAmount > 0;
            })
            .finally(function () {
              vm.loading--;
            });
        }

        vm.cancel = function () {
          $uibModalInstance.dismiss();
        };

        init();
      },
    ]);
})();
